import isGiftUrlLocationUtil from 'utils/location/is-gift-url'
import isAddAGiftCardStepGiftSelect from 'modules/gift/redux/selectors/is-add-a-gift-card-step'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import isSamplesCollectionUrlLocationUtil from 'utils/location/is-samples-collection-url'
import isSampleSubCollectionUrlLocationUtil from 'utils/location/is-sample-sub-collection'
import shouldHideVariantButtonsSelectorUtil from 'containers/QuickShopProductSidebar/components/VariantButtons/selectors/should-hide-variant-buttons/utils'

const shouldHideVariantButtonsSelector = () => {
  return shouldHideVariantButtonsSelectorUtil({
    isGiftUrl: isGiftUrlLocationUtil(),
    isAddAGiftCardStep: isAddAGiftCardStepGiftSelect(),
    isSelfGifting: isSelfGiftingUrlLocationUtil(),
    isSampleCollection: isSamplesCollectionUrlLocationUtil(),
    isSampleSubCollection: isSampleSubCollectionUrlLocationUtil()
  })
}

export default shouldHideVariantButtonsSelector
